import { ValidationModel, ValidationType } from "@/services/validation/types";

export const settingsValidators = {
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 3 }
        ]
    } as ValidationModel
};
